export const cardiologyConst = {
  path: "/single-programs/cardiology",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ОТОРИНОЛАРИНГОЛОГИЯ (ЛОР)",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Кардиология — профессия, которая лечит сердца</h2>
      <p>
        Кардиология — это одна из самых важных и динамично развивающихся областей медицины. Она занимается диагностикой, лечением и
        профилактикой заболеваний сердца и сосудов, включая ишемическую болезнь, инфаркты, аритмии, гипертонию и сердечную недостаточность.
      </p>
      <p>
        Программа обучения сочетает глубокую теоретическую подготовку, освоение современных диагностических методов и обширную клиническую
        практику под руководством опытных специалистов.
      </p>
      <br />
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Анатомия и физиология сердечно-сосудистой системы</li>
        <li>Кардиологическая диагностика: ЭКГ, ЭхоКГ, холтеровское мониторирование</li>
        <li>Лечение острых и хронических кардиозаболеваний</li>
        <li>Неотложная помощь при инфаркте, аритмии, гипертоническом кризе</li>
        <li>Медикаментозная и интервенционная терапия</li>
        <li>Кардиореабилитация и профилактика</li>
        <li>Смежные дисциплины: пульмонология, эндокринология, нефрология</li>
        <li>Медицинская этика и коммуникация с пациентами</li>
      </ul>
      <p>
        В рамках практики — клинические стажировки в кардиологических центрах, работа с реальными случаями, участие в научных конференциях.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Врач-кардиолог в клиниках, больницах и диагностических центрах</li>
        <li>Врач функциональной диагностики</li>
        <li>Специалист по неотложной кардиологической помощи</li>
        <li>Реабилитолог по сердечно-сосудистым заболеваниям</li>
        <li>Медицинский консультант или научный сотрудник в области кардиологии</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Заболевания сердца — ведущая причина смертности в мире. Квалифицированные кардиологи нужны в каждой стране.</p>
      <p>
        <strong>Средний уровень дохода в Европе — от €65,000 до €120,000 в год,</strong> особенно в частной практике и специализированных
        центрах.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом магистра</li>
        <li>Обучение на русском и английском языках</li>
        <li>Гибкий график — очно или дистанционно</li>
        <li>Современная диагностика и симуляционные технологии</li>
        <li>Стажировки в кардиологических клиниках ЕС</li>
        <li>Индивидуальное сопровождение студента от поступления до трудоустройства</li>
      </ul>
      <h2>Учёба, которая спасает жизни</h2>
      <p>
        Кардиология требует точности, внимания и глубокой эмпатии. Мы готовим специалистов, способных принимать жизненно важные решения и
        работать в условиях высокой ответственности.
      </p>
      <br />
      <p className="padding-left">«Кардиология — это не только наука, но и искусство слышать и понимать сердце.»</p>
      <h2>Как поступить?</h2>
      <p>Заполните анкету, прикрепите документы и получите консультацию приемной комиссии. Мы подскажем, как начать путь в кардиологии.</p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Кардиология — профессия, которая лечит сердца
    Кардиология — это одна из самых важных и динамично развивающихся областей медицины. Она занимается диагностикой, лечением и профилактикой заболеваний сердца и сосудов, включая ишемическую болезнь, инфаркты, аритмии, гипертонию и сердечную недостаточность.
    Программа обучения сочетает глубокую теоретическую подготовку, освоение современных диагностических методов и обширную клиническую практику под руководством опытных специалистов.

    Что вы будете изучать?
    • Анатомия и физиология сердечно-сосудистой системы
    • Кардиологическая диагностика: ЭКГ, ЭхоКГ, холтеровское мониторирование
    • Лечение острых и хронических кардиозаболеваний
    • Неотложная помощь при инфаркте, аритмии, гипертоническом кризе
    • Медикаментозная и интервенционная терапия
    • Кардиореабилитация и профилактика
    • Смежные дисциплины: пульмонология, эндокринология, нефрология
    • Медицинская этика и коммуникация с пациентами
    В рамках практики — клинические стажировки в кардиологических центрах, работа с реальными случаями, участие в научных конференциях.

    Кем можно работать после окончания?
    • Врач-кардиолог в клиниках, больницах и диагностических центрах
    • Врач функциональной диагностики
    • Специалист по неотложной кардиологической помощи
    • Реабилитолог по сердечно-сосудистым заболеваниям
    • Медицинский консультант или научный сотрудник в области кардиологии

    Востребованность и доход
    Заболевания сердца — ведущая причина смертности в мире. Квалифицированные кардиологи нужны в каждой стране.
    Средний уровень дохода в Европе — от €65,000 до €120,000 в год, особенно в частной практике и специализированных центрах.

    Почему выбирают нас?
    • Европейский диплом магистра
    • Обучение на русском и английском языках
    • Гибкий график — очно или дистанционно
    • Современная диагностика и симуляционные технологии
    • Стажировки в кардиологических клиниках ЕС
    • Индивидуальное сопровождение студента от поступления до трудоустройства

    Учёба, которая спасает жизни
    Кардиология требует точности, внимания и глубокой эмпатии. Мы готовим специалистов, способных принимать жизненно важные решения и работать в условиях высокой ответственности.
    «Кардиология — это не только наука, но и искусство слышать и понимать сердце.»

    Как поступить?
    Заполните анкету, прикрепите документы и получите консультацию приемной комиссии. Мы подскажем, как начать путь в кардиологии. 
  `,
};
